// window.theme = window.theme || {};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class App {
  constructor() {
    this.calcHeaderAnnouncementBarHeight();
    this.calcViewport();
    this.eventListeners();
    this.addThemeInfo();
    this.setFirstSession();
    this.observeRTLChanges();
  }

  addThemeInfo() {
    if (window.theme === undefined) return;
    document.documentElement.setAttribute("data-theme-name", window.theme.info.name);
    document.documentElement.setAttribute("data-theme-version", window.theme.info.version);
  }

  isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  isFirstSession() {
    return sessionStorage.getItem("firstSession") === null;
  }

  isRTL() {
    return document.documentElement.dir === 'rtl';
  }

  setFirstSession() {
    if (this.isFirstSession()) {
      sessionStorage.setItem("firstSession", true);
      document.documentElement.setAttribute("data-first-session", true);
    } else {
      document.documentElement.setAttribute("data-first-session", false);
    }
  }


  calcViewport() {
    let vh = window.innerHeight * 0.01;
    let vw = window.innerWidth * 0.01;

    document.documentElement.style.setProperty("--vh", `${vh}px`);
    document.documentElement.style.setProperty("--vw", `${vw}px`);
  }

  calcHeaderAnnouncementBarHeight() {
    let header = document.querySelector(".shopify-section-header");
    let announcementbar = document.querySelector(".shopify-section-announcement-bar");

    let height = 0;
    let headerHeight = header ? header.getBoundingClientRect().height : 0;
    let announcementbarHeight = announcementbar ? announcementbar.getBoundingClientRect().height : 0;

    document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
    document.documentElement.style.setProperty("--announcement-bar-height", `${announcementbarHeight}px`);


    height = headerHeight + announcementbarHeight;
    document.documentElement.style.setProperty("--top-content-height", `${height}px`);

    // return height;
  }

  onResize() {
    this.calcViewport();
    this.calcHeaderAnnouncementBarHeight();
  }

  observeRTLChanges() {
    const targetNode = document.documentElement; // Typically the <html> element
    const config = {
      attributes: true
    };

    const callback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'dir') {
          this.isRTL = document.documentElement.getAttribute('dir') === 'rtl';
          this.emitRTLChange(); // Emit an event when direction changes
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  emitRTLChange() {
    const event = new CustomEvent('rtlChange', {
      detail: {
        isRTL: this.isRTL
      }
    });
    window.dispatchEvent(event);
  }

  eventListeners() {
    window.addEventListener("resize", this.onResize.bind(this));
  }
}

window.app = new App();

window.SkinNoteCartLimit = window.SkinNoteCartLimit || (() => {
  const maxPerVariant = 15;

  function message(limit = maxPerVariant) {
    if (Number.isFinite(limit) && limit < maxPerVariant) {
      return `Only ${limit} available for this item right now.`;
    }

    return `You can only add ${limit} of this item to your cart.`;
  }

  function getCartScope() {
    const drawer = document.getElementById('CartDrawer');
    if (drawer?.querySelector?.('[data-quantity-variant-id]')) return drawer;

    const cart = document.getElementById('Cart');
    if (cart?.querySelector?.('[data-quantity-variant-id]')) return cart;

    return document;
  }

  function getKnownQuantity(variantId) {
    if (!variantId) return 0;

    const escapedVariantId = window.CSS?.escape
      ? CSS.escape(String(variantId))
      : String(variantId).replace(/"/g, '\\"');
    const selector = `[data-quantity-variant-id="${escapedVariantId}"]`;
    return Array.from(getCartScope().querySelectorAll(selector)).reduce((total, input) => {
      const value = parseInt(input.value);
      return total + (Number.isFinite(value) ? value : 0);
    }, 0);
  }

  function getRequestedQuantity(source) {
    if (!source) return 1;

    const quantityInput = source.querySelector?.('[name="quantity"]');
    const value = parseInt(quantityInput?.value || source.get?.('quantity'));
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function wouldExceed(variantId, quantity = 1) {
    return getKnownQuantity(variantId) + Math.max(1, quantity) > maxPerVariant;
  }

  function showInlineError(anchor, text = message()) {
    const parent = anchor?.parentElement;
    if (!parent) return;

    let feedback = parent.querySelector(':scope > .skn-cart-limit-message');
    if (!feedback) {
      feedback = document.createElement('small');
      feedback.className = 'skn-cart-limit-message message-error';
      feedback.setAttribute('role', 'alert');
      parent.appendChild(feedback);
    }

    feedback.textContent = text;
    feedback.classList.add('is-visible');

    window.clearTimeout(feedback.sknHideTimer);
    feedback.sknHideTimer = window.setTimeout(() => {
      feedback.classList.remove('is-visible');
    }, 4200);
  }

  return {
    maxPerVariant,
    message,
    getKnownQuantity,
    getRequestedQuantity,
    wouldExceed,
    showInlineError,
  };
})();

window.SkinNoteProductInventory = window.SkinNoteProductInventory || (() => {
  const cache = new WeakMap();

  function parseInventory(form) {
    const productForm = form?.closest?.('product-form');
    const script = productForm?.querySelector?.('[data-skn-product-inventory]');
    if (!script) return {};
    if (cache.has(script)) return cache.get(script);

    try {
      const parsed = JSON.parse(script.textContent || '{}');
      cache.set(script, parsed);
      return parsed;
    } catch (error) {
      console.error(error);
      cache.set(script, {});
      return {};
    }
  }

  function getVariantId(form) {
    return form?.querySelector?.('[name="id"]')?.value;
  }

  function getQuantityInput(form) {
    return form?.querySelector?.('input[name="quantity"]');
  }

  function getRecord(form, variantId = getVariantId(form)) {
    return parseInventory(form)?.[String(variantId)] || null;
  }

  function getLimit(form, variantId = getVariantId(form)) {
    const record = getRecord(form, variantId);
    let limit = window.SkinNoteCartLimit?.maxPerVariant || 15;

    if (record?.inventory_management && record.inventory_policy === 'deny') {
      const inventoryQuantity = parseInt(record.inventory_quantity);
      if (Number.isFinite(inventoryQuantity)) {
        limit = Math.min(limit, Math.max(0, inventoryQuantity));
      }
    }

    const ruleMax = parseInt(record?.quantity_rule_max);
    if (Number.isFinite(ruleMax) && ruleMax > 0) {
      limit = Math.min(limit, ruleMax);
    }

    return limit;
  }

  function syncForm(form, options = {}) {
    const input = getQuantityInput(form);
    if (!input) return { ok: true };

    const variantId = getVariantId(form);
    const record = getRecord(form, variantId);
    const limit = getLimit(form, variantId);
    const min = Math.max(1, parseInt(record?.quantity_rule_min) || parseInt(input.min) || 1);
    const step = Math.max(1, parseInt(record?.quantity_rule_increment) || parseInt(input.step) || 1);
    const safeMax = limit > 0 ? limit : min;
    let value = parseInt(input.value);
    let clamped = false;

    if (!Number.isFinite(value) || value < min) {
      value = min;
      clamped = true;
    }

    if (limit > 0 && value > limit) {
      value = limit;
      clamped = true;
    }

    input.min = min;
    input.step = step;
    input.max = safeMax;
    input.dataset.sknVariantLimit = String(limit);
    input.dataset.sknVariantId = String(variantId || '');
    input.value = value;

    const quantityInput = input.closest('quantity-input');
    quantityInput?.validateQtyRules?.(value);

    if (clamped && options.showError) {
      form.closest('product-form')?.handleErrorMessage?.(window.SkinNoteCartLimit?.message?.(limit));
    }

    return { ok: true, clamped, limit, value, record };
  }

  function validateAdd(form) {
    const synced = syncForm(form, { showError: false });
    const input = getQuantityInput(form);
    const variantId = getVariantId(form);
    const limit = synced.limit ?? getLimit(form, variantId);
    const requestedQuantity = Math.max(1, parseInt(input?.value) || 1);
    const knownQuantity = window.SkinNoteCartLimit?.getKnownQuantity?.(variantId) || 0;
    const remaining = limit - knownQuantity;

    if (limit <= 0) {
      return { ok: false, message: 'This item is currently unavailable.' };
    }

    if (synced.clamped) {
      return { ok: false, message: window.SkinNoteCartLimit?.message?.(limit) };
    }

    if (requestedQuantity > limit) {
      if (input) input.value = limit;
      input?.closest('quantity-input')?.validateQtyRules?.(limit);
      return { ok: false, message: window.SkinNoteCartLimit?.message?.(limit) };
    }

    if (remaining <= 0) {
      return { ok: false, message: window.SkinNoteCartLimit?.message?.(limit) };
    }

    if (requestedQuantity > remaining) {
      if (input) input.value = remaining;
      input?.closest('quantity-input')?.validateQtyRules?.(remaining);
      const unit = remaining === 1 ? 'item' : 'items';
      return { ok: false, message: `Only ${remaining} more ${unit} can be added right now.` };
    }

    return { ok: true, limit, remaining };
  }

  function syncAll(root = document, options = {}) {
    root.querySelectorAll?.('product-form form[action*="/cart/add"], product-form form[data-type="add-to-cart-form"]').forEach((form) => {
      syncForm(form, options);
    });
  }

  document.addEventListener('DOMContentLoaded', () => syncAll());
  document.addEventListener('change', (event) => {
    if (event.target?.matches?.('product-form [name="id"]')) {
      syncForm(event.target.closest('form'), { showError: true });
    }
  });

  if ('MutationObserver' in window) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) syncAll(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  return { getRecord, getLimit, syncForm, syncAll, validateAdd };
})();

window.SkinNoteHeroStability = window.SkinNoteHeroStability || (() => {
  const mobileQuery = window.matchMedia('(max-width: 59.99em)');
  let lastWidth = 0;
  let stableVh = 0;

  function getViewportHeight() {
    return window.visualViewport?.height || window.innerHeight || document.documentElement.clientHeight;
  }

  function setStableHeroHeight(force = false) {
    if (!mobileQuery.matches) {
      document.documentElement.style.removeProperty('--skn-hero-mobile-vh');
      stableVh = 0;
      lastWidth = window.innerWidth;
      return;
    }

    const currentWidth = window.innerWidth || document.documentElement.clientWidth;
    const widthChanged = Math.abs(currentWidth - lastWidth) > 2;
    if (!force && stableVh && !widthChanged) return;

    lastWidth = currentWidth;
    stableVh = getViewportHeight() * 0.01;
    document.documentElement.style.setProperty('--skn-hero-mobile-vh', `${stableVh}px`);
  }

  setStableHeroHeight(true);
  window.addEventListener('DOMContentLoaded', () => setStableHeroHeight(true), { once: true });
  window.addEventListener('load', () => setStableHeroHeight(false), { once: true });
  window.addEventListener('resize', () => setStableHeroHeight(false), { passive: true });
  window.visualViewport?.addEventListener('resize', () => setStableHeroHeight(false), { passive: true });

  return { setStableHeroHeight };
})();

window.SkinNoteFeedback = window.SkinNoteFeedback || (() => {
  let transitionTimer = null;

  function isPlainInternalNavigation(event, link) {
    if (!link || !link.href) return false;
    if (event.defaultPrevented) return false;
    if (event.button && event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (link.target && link.target !== '_self') return false;
    if (link.hasAttribute('download')) return false;
    if (link.getAttribute('aria-disabled') === 'true') return false;
    if (link.matches('.header__icon--search')) return false;
    if (link.closest('quick-add-modal')) return false;

    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return false;

    return true;
  }

  function startPageTransition(link) {
    window.clearTimeout(transitionTimer);
    document.body.classList.add('is-page-transitioning');
    const buttonLike = link?.matches?.('.btn, .cta-btn') ? link : link?.querySelector?.('.btn, .cta-btn');
    if (buttonLike) {
      buttonLike.classList.add('is-link-loading');
      buttonLike.setAttribute('aria-busy', 'true');
    }

    transitionTimer = window.setTimeout(clearPageTransition, 8000);
  }

  function clearPageTransition() {
    window.clearTimeout(transitionTimer);
    document.body.classList.remove('is-page-transitioning');
    document.querySelectorAll('.btn.is-link-loading').forEach((button) => {
      button.classList.remove('is-link-loading');
      button.removeAttribute('aria-busy');
    });
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!isPlainInternalNavigation(event, link)) return;
    startPageTransition(link);
  }, { capture: true });

  document.addEventListener('click', (event) => {
    const checkoutButton = event.target.closest('button[name="checkout"]');
    if (!checkoutButton || checkoutButton.disabled || event.defaultPrevented) return;
    checkoutButton.classList.add('is-link-loading');
    checkoutButton.setAttribute('aria-busy', 'true');
    document.body.classList.add('is-page-transitioning');
  }, { capture: true });

  document.addEventListener('submit', (event) => {
    if (event.defaultPrevented) return;
    const form = event.target;
    if (!form?.matches?.('form')) return;
    if (form.closest('cart-drawer, product-form, quick-add-modal') || form.matches('.customer-account-form')) return;

    const submitButton = form.querySelector('button[type="submit"], button:not([type]), .btn');
    if (submitButton?.classList?.contains('btn')) {
      submitButton.classList.add('is-link-loading');
      submitButton.setAttribute('aria-busy', 'true');
    }
  }, { capture: true });

  window.addEventListener('pageshow', clearPageTransition);
  window.addEventListener('pagehide', clearPageTransition);

  return { startPageTransition, clearPageTransition };
})();

window.SkinNoteAccountTabs = window.SkinNoteAccountTabs || (() => {
  function setActiveTab(root, activeTab) {
    const normalizedTab = activeTab === 'register' ? 'register' : 'login';
    const previousPanel = root.querySelector('[data-account-panel].is-active');
    const nextPanel = root.querySelector(`[data-account-panel="${normalizedTab}"]`);
    const switcher = root.querySelector('[data-active-tab]');

    if (!nextPanel || previousPanel === nextPanel) return;
    if (switcher) switcher.dataset.activeTab = normalizedTab;

    root.querySelectorAll('[data-account-tab]').forEach((button) => {
      const isActive = button.dataset.accountTab === normalizedTab;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (previousPanel) {
      previousPanel.classList.remove('is-active', 'is-entering', 'is-leaving');
      previousPanel.setAttribute('hidden', '');
    }

    nextPanel.removeAttribute('hidden');
    nextPanel.classList.remove('is-leaving', 'is-active');
    nextPanel.classList.add('is-entering');

    requestAnimationFrame(() => {
      nextPanel.classList.add('is-active');
      nextPanel.classList.remove('is-entering');
    });

    window.setTimeout(() => {
      root.querySelectorAll('[data-account-panel]').forEach((panel) => {
        const isActive = panel === nextPanel;
        panel.classList.toggle('is-active', isActive);
        panel.classList.remove('is-leaving', 'is-entering');
        panel.toggleAttribute('hidden', !isActive);
      });
    }, 460);

    if (window.location.hash !== `#${normalizedTab}`) {
      history.replaceState(null, '', `#${normalizedTab}`);
    }
  }

  function getFieldMessage(field) {
    if (field.validity.valueMissing) return field.dataset.accountRequiredMessage || 'Please fill out this field.';
    if (field.validity.typeMismatch || field.validity.patternMismatch) return field.dataset.accountInvalidMessage || 'Please check this field.';
    return field.validationMessage || 'Please check this field.';
  }

  function renderFieldError(field, message) {
    const fieldShell = field.closest('.field') || field.parentElement;
    if (!fieldShell) return;

    field.setAttribute('aria-invalid', 'true');
    fieldShell.classList.add('has-validation-error');

    let error = fieldShell.querySelector('.customer-field-error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'customer-field-error';
      error.id = `${field.id || field.name.replace(/\W+/g, '-')}-Error`;
      fieldShell.appendChild(error);
    }

    field.setAttribute('aria-describedby', error.id);
    error.textContent = message;
  }

  function clearFieldError(field) {
    const fieldShell = field.closest('.field') || field.parentElement;
    field.removeAttribute('aria-invalid');
    if (!fieldShell) return;

    fieldShell.classList.remove('has-validation-error');
    const error = fieldShell.querySelector('.customer-field-error');
    if (error) error.remove();
  }

  function validateForm(form) {
    const fields = [...form.querySelectorAll('input[required]')];
    const invalidFields = [];

    fields.forEach((field) => {
      if (field.checkValidity()) {
        clearFieldError(field);
        return;
      }

      invalidFields.push(field);
      renderFieldError(field, getFieldMessage(field));
    });

    const feedback = form.querySelector('[data-account-form-feedback]');
    if (feedback) {
      if (invalidFields.length) {
        feedback.hidden = false;
        feedback.textContent = 'Please check the highlighted fields before continuing.';
      } else {
        feedback.hidden = true;
        feedback.textContent = '';
      }
    }

    return invalidFields;
  }

  function validateLoginForm(form) {
    const fields = [...form.querySelectorAll('input[required]')];
    const invalidFields = [];

    fields.forEach((field) => {
      const value = (field.value || '').trim();
      const isEmail = field.type === 'email';
      const isInvalid = !value || (isEmail && !value.includes('@'));

      if (!isInvalid) {
        clearFieldError(field);
        return;
      }

      invalidFields.push(field);
      renderFieldError(field, getFieldMessage(field));
    });

    const feedback = form.querySelector('[data-account-form-feedback]');
    if (feedback) {
      if (invalidFields.length) {
        feedback.hidden = false;
        feedback.textContent = 'Please check the highlighted fields before continuing.';
      } else {
        feedback.hidden = true;
        feedback.textContent = '';
      }
    }

    return invalidFields;
  }

  function focusInvalidField(form, invalidFields) {
    form.classList.remove('has-submit-error');
    void form.offsetWidth;
    form.classList.add('has-submit-error');

    try {
      invalidFields[0].focus({ preventScroll: true });
    } catch (error) {
      invalidFields[0].focus();
    }
  }

  function handleSubmit(event) {
    const form = event.target;
    if (!form?.matches?.('.customer-account-form')) return;

    if (form.id === 'CustomerLoginForm') {
      const invalidFields = validateLoginForm(form);
      if (!invalidFields.length) return;

      event.preventDefault();
      event.stopPropagation();
      focusInvalidField(form, invalidFields);
      return;
    }

    const invalidFields = validateForm(form);
    if (!invalidFields.length) {
      const submitButton = form.querySelector('button[type="submit"], button:not([type]), .btn');
      if (submitButton?.classList?.contains('btn')) {
        submitButton.classList.add('is-link-loading');
        submitButton.setAttribute('aria-busy', 'true');
        window.setTimeout(() => {
          if (!document.documentElement.contains(form)) return;
          submitButton.classList.remove('is-link-loading');
          submitButton.removeAttribute('aria-busy');
        }, 4500);
      }
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    form.classList.remove('has-submit-error');
    void form.offsetWidth;
    form.classList.add('has-submit-error');

    try {
      invalidFields[0].focus({ preventScroll: true });
    } catch (error) {
      invalidFields[0].focus();
    }
  }

  function init(root = document) {
    root.querySelectorAll('[data-account-tabs]').forEach((tabs) => {
      const panelRoot = tabs.parentElement?.querySelector('[data-account-panels]');
      if (!panelRoot || tabs.dataset.accountTabsReady === 'true') return;
      tabs.dataset.accountTabsReady = 'true';

      const initialTab =
        window.location.pathname.includes('/register') || window.location.hash === '#register'
          ? 'register'
          : 'login';

      const switcher = tabs.querySelector('[data-active-tab]');
      if (switcher) switcher.dataset.activeTab = initialTab;

      tabs.parentElement.querySelectorAll('[data-account-panel]').forEach((panel) => {
        const isActive = panel.dataset.accountPanel === initialTab;
        panel.classList.toggle('is-active', isActive);
        panel.toggleAttribute('hidden', !isActive);
      });

      tabs.querySelectorAll('[data-account-tab]').forEach((button) => {
        const isActive = button.dataset.accountTab === initialTab;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      tabs.querySelectorAll('[data-account-tab]').forEach((button) => {
        button.addEventListener('click', () => {
          setActiveTab(tabs.parentElement, button.dataset.accountTab);
        });
      });
    });

    root.querySelectorAll('.customer-account-form').forEach((form) => {
      if (form.dataset.accountValidationReady === 'true') return;
      form.dataset.accountValidationReady = 'true';

      form.addEventListener('submit', handleSubmit, { capture: true });
      form.querySelectorAll('input[required]').forEach((field) => {
        field.addEventListener('input', () => {
          if (field.getAttribute('aria-invalid') === 'true') {
            if (field.checkValidity()) clearFieldError(field);
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => init());
  init();

  return { init, setActiveTab };
})();

window.SkinNoteDrawers = window.SkinNoteDrawers || (() => {
  const locks = new Set();
  let scrollY = 0;
  let previousHtmlStyles = {};
  let previousBodyStyles = {};
  let previousScrollBehavior = '';
  let viewportFrame = null;
  let lastViewportWidth = window.innerWidth;
  let lockedTouchStart = null;
  let pendingLockScroll = null;
  let settledScrollY = window.scrollY || window.pageYOffset || 0;
  let settledScrollAt = 0;
  let hasSettledScroll = false;
  let settleScrollTimer = null;

  function setViewportHeight() {
    const viewport = window.visualViewport;
    const height = viewport ? viewport.height : window.innerHeight;
    document.documentElement.style.setProperty('--skn-viewport-height', `${height}px`);
  }

  function lock(name = 'drawer') {
    setViewportHeight();
    if (!locks.size) {
      const pendingScrollY =
        pendingLockScroll && Date.now() - pendingLockScroll.at < 900
          ? pendingLockScroll.y
          : null;
      const currentScrollY = window.scrollY || window.pageYOffset || 0;
      const settledScrollIsFresh = hasSettledScroll && Date.now() - settledScrollAt < 2500;
      const currentLooksJittered = Math.abs(currentScrollY - settledScrollY) > 12;
      const stableScrollY = settledScrollIsFresh && currentLooksJittered ? settledScrollY : currentScrollY;
      scrollY = pendingScrollY ?? stableScrollY;
      pendingLockScroll = null;
      previousScrollBehavior = document.documentElement.style.scrollBehavior;
      previousHtmlStyles = {
        overflow: document.documentElement.style.overflow,
        overscrollBehavior: document.documentElement.style.overscrollBehavior,
      };
      previousBodyStyles = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        right: document.body.style.right,
        width: document.body.style.width,
        paddingRight: document.body.style.paddingRight,
        overflow: document.body.style.overflow,
        overscrollBehavior: document.body.style.overscrollBehavior,
      };

      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.scrollBehavior = 'auto';
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.overscrollBehavior = 'none';
      document.documentElement.classList.add('skn-drawer-locked');
      document.body.classList.add('skn-drawer-body-locked');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.body.style.overscrollBehavior = 'none';
      if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
    locks.add(name);
  }

  function unlock(name = 'drawer') {
    const hadLock = locks.delete(name);
    if (!hadLock && !locks.size) return;
    if (locks.size) return;

    document.documentElement.classList.remove('skn-drawer-locked');
    document.body.classList.remove('skn-drawer-body-locked');
    document.documentElement.style.overflow = previousHtmlStyles.overflow || '';
    document.documentElement.style.overscrollBehavior = previousHtmlStyles.overscrollBehavior || '';
    document.body.style.position = previousBodyStyles.position || '';
    document.body.style.top = previousBodyStyles.top || '';
    document.body.style.left = previousBodyStyles.left || '';
    document.body.style.right = previousBodyStyles.right || '';
    document.body.style.width = previousBodyStyles.width || '';
    document.body.style.paddingRight = previousBodyStyles.paddingRight || '';
    document.body.style.overflow = previousBodyStyles.overflow || '';
    document.body.style.overscrollBehavior = previousBodyStyles.overscrollBehavior || '';

    window.scrollTo(0, scrollY);
    requestAnimationFrame(() => {
      document.documentElement.style.scrollBehavior = previousScrollBehavior;
    });
  }

  function restoreScroll(attempts = 4) {
    const targetY = scrollY;
    let count = 0;

    const restore = () => {
      window.scrollTo(0, targetY);
      count += 1;

      if (count < attempts) {
        requestAnimationFrame(restore);
      }
    };

    requestAnimationFrame(restore);
  }

  function rememberScroll() {
    if (locks.size) return;
    pendingLockScroll = {
      y: window.scrollY || window.pageYOffset || 0,
      at: Date.now(),
    };
  }

  function rememberSettledScroll() {
    if (locks.size) return;
    window.clearTimeout(settleScrollTimer);
    const nextScrollY = window.scrollY || window.pageYOffset || 0;

    settleScrollTimer = window.setTimeout(() => {
      if (locks.size) return;
      settledScrollY = nextScrollY;
      settledScrollAt = Date.now();
      hasSettledScroll = true;
    }, 140);
  }

  function getScrollY() {
    return scrollY;
  }

  function isHorizontalRail(target) {
    return Boolean(target?.closest?.('.predictive-search-results__list, .search-modal__featured-items > ul, .cart-essentials__track'));
  }

  function isDrawerScroller(target) {
    return Boolean(target?.closest?.('#MenuDrawer, .cart-drawer__inner, .cart-drawer__items'));
  }

  function isMostlyVerticalMove(event) {
    if (event.type === 'wheel') {
      return Math.abs(event.deltaY) >= Math.abs(event.deltaX);
    }

    const touch = event.touches?.[0];
    const start = lockedTouchStart || {};
    if (!touch || start.x === undefined || start.y === undefined) return true;

    const deltaX = Math.abs(touch.clientX - start.x);
    const deltaY = Math.abs(touch.clientY - start.y);
    return deltaY >= deltaX + 4;
  }

  function onLockedTouchStart(event) {
    if (!locks.size) return;
    const touch = event.touches?.[0];
    if (!touch) return;
    lockedTouchStart = {
      x: touch.clientX,
      y: touch.clientY,
      target: event.target,
    };
  }

  function onLockedMove(event) {
    if (!locks.size) return;

    if (locks.has('search')) {
      if (event.type === 'touchmove' && isHorizontalRail(event.target)) {
        const touch = event.touches?.[0];
        const start = lockedTouchStart || {};
        const deltaX = touch ? Math.abs(touch.clientX - (start.x || touch.clientX)) : 0;
        const deltaY = touch ? Math.abs(touch.clientY - (start.y || touch.clientY)) : 0;
        if (deltaX > deltaY + 4) return;
      }

      if (event.type === 'wheel' && isHorizontalRail(event.target) && Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
        return;
      }

      event.preventDefault();
      return;
    }

    if (isHorizontalRail(event.target)) {
      if (event.type === 'touchmove') {
        const touch = event.touches?.[0];
        const start = lockedTouchStart || {};
        const deltaX = touch ? Math.abs(touch.clientX - (start.x || touch.clientX)) : 0;
        const deltaY = touch ? Math.abs(touch.clientY - (start.y || touch.clientY)) : 0;
        if (deltaX > deltaY + 4) return;
      }

      if (event.type === 'wheel' && Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
    }

    if (isDrawerScroller(event.target)) {
      if (isMostlyVerticalMove(event)) return;
      event.preventDefault();
      return;
    }

    event.preventDefault();
  }

  function scheduleViewportHeight() {
    const currentWidth = window.innerWidth;
    if (!locks.size && Math.abs(currentWidth - lastViewportWidth) < 2) return;
    lastViewportWidth = currentWidth;
    if (viewportFrame) cancelAnimationFrame(viewportFrame);
    viewportFrame = requestAnimationFrame(setViewportHeight);
  }

  setViewportHeight();
  window.addEventListener('scroll', rememberSettledScroll, { passive: true });
  window.addEventListener('resize', scheduleViewportHeight, { passive: true });
  document.addEventListener('touchstart', onLockedTouchStart, { passive: true });
  document.addEventListener('touchmove', onLockedMove, { passive: false });
  document.addEventListener('wheel', onLockedMove, { passive: false });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleViewportHeight, { passive: true });
  }

  return { lock, unlock, setViewportHeight, restoreScroll, rememberScroll, getScrollY };
})();

window.SkinNoteHeaderTapGuard = window.SkinNoteHeaderTapGuard || (() => {
  const mobileQuery = window.matchMedia('(max-width: 59.99em)');
  let lastForwardedAt = 0;

  function expandedRect(element, padding = 12) {
    if (!element) return null;
    const rect = element.getBoundingClientRect();
    if (!rect.width || !rect.height) return null;
    return {
      top: rect.top - padding,
      right: rect.right + padding,
      bottom: rect.bottom + padding,
      left: rect.left - padding,
    };
  }

  function pointInRect(x, y, rect) {
    return rect && x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  }

  function getClientPoint(event) {
    const touch = event.changedTouches?.[0] || event.touches?.[0];
    if (touch) return { x: touch.clientX, y: touch.clientY };
    return { x: event.clientX, y: event.clientY };
  }

  function getCssPixelValue(name) {
    const value = getComputedStyle(document.documentElement).getPropertyValue(name);
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function getHeaderActionBand() {
    const announcementHeight =
      getCssPixelValue('--announcement-bar-height') ||
      document.querySelector('.shopify-section-announcement-bar')?.getBoundingClientRect().height ||
      0;
    const headerHeight =
      getCssPixelValue('--header-height') ||
      document.querySelector('.shopify-section-header')?.getBoundingClientRect().height ||
      64;

    return {
      top: Math.max(0, announcementHeight - 8),
      bottom: announcementHeight + headerHeight + 12,
    };
  }

  function isVisibleAction(element) {
    if (!element) return false;
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function getVisibleActions() {
    const cartCloseButton = document.querySelector('#CartDrawer-Close');
    const closeButton = document.querySelector('#MenuDrawer-CloseIcon');
    const hamburgerButton = document.querySelector('#MenuDrawer-HamburgerIcon');
    const logoLink = document.querySelector('.header__heading-link');
    const searchButton = document.querySelector('.header__icon--search');
    const cartButton = document.querySelector('#cart-icon-bubble');

    return [cartCloseButton, closeButton, hamburgerButton, logoLink, searchButton, cartButton].filter(isVisibleAction);
  }

  function getNearestAction(x, y, actions) {
    let best = null;
    let bestDistance = Number.POSITIVE_INFINITY;

    actions.forEach((action) => {
      const rect = action.getBoundingClientRect();
      const expanded = expandedRect(action, 22);
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      const distance = Math.hypot(x - centerX, y - centerY);

      if (pointInRect(x, y, expanded) && distance < bestDistance) {
        best = action;
        bestDistance = distance;
      }
    });

    return best;
  }

  function getHeaderAction(x, y) {
    const band = getHeaderActionBand();
    if (y < band.top || y > band.bottom) return null;

    return getNearestAction(x, y, getVisibleActions());
  }

  function handleHeaderTap(event) {
    if (!mobileQuery.matches || !event.isTrusted) return;
    if (Date.now() - lastForwardedAt < 300) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    const point = getClientPoint(event);
    const action = getHeaderAction(point.x, point.y);
    if (!action) return;

    const nativeAction = event.target.closest?.('#CartDrawer-Close, #MenuDrawer-CloseIcon, #MenuDrawer-HamburgerIcon, .header__heading-link, .header__icon--search, #cart-icon-bubble');
    if (nativeAction === action) return;

    event.preventDefault();
    event.stopPropagation();
    lastForwardedAt = Date.now();
    action.click();
  }

  function rememberHeaderScroll(event) {
    if (!mobileQuery.matches || !event.isTrusted) return;

    const point = getClientPoint(event);
    if (!getHeaderAction(point.x, point.y)) return;

    window.SkinNoteDrawers?.rememberScroll?.();
  }

  document.addEventListener('pointerdown', rememberHeaderScroll, { capture: true, passive: true });
  document.addEventListener('mousedown', rememberHeaderScroll, { capture: true, passive: true });
  document.addEventListener('touchstart', rememberHeaderScroll, { capture: true, passive: true });
  document.addEventListener('click', handleHeaderTap, { capture: true });
  document.addEventListener('touchend', handleHeaderTap, { capture: true, passive: false });

  return { handleHeaderTap };
})();

window.SkinNoteMenuTapDebounce = window.SkinNoteMenuTapDebounce || (() => {
  const mobileQuery = window.matchMedia('(max-width: 59.99em)');
  let lastMenuTapAt = 0;
  let busyTimer = null;

  function handleMenuTap(event) {
    if (!mobileQuery.matches || !event.isTrusted) return;

    const button = event.target.closest?.('#MenuDrawer-HamburgerIcon, #MenuDrawer-CloseIcon');
    if (!button) return;

    const now = Date.now();
    if (now - lastMenuTapAt < 650) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    lastMenuTapAt = now;
    button.setAttribute('aria-busy', 'true');
    window.clearTimeout(busyTimer);
    busyTimer = window.setTimeout(() => {
      document.querySelectorAll('#MenuDrawer-HamburgerIcon[aria-busy], #MenuDrawer-CloseIcon[aria-busy]').forEach((item) => {
        item.removeAttribute('aria-busy');
      });
    }, 650);
  }

  document.addEventListener('click', handleMenuTap, { capture: true });

  return { handleMenuTap };
})();

window.SkinNoteCartEssentialsRail = window.SkinNoteCartEssentialsRail || (() => {
  let activeRail = null;
  let activePointerId = null;
  let startX = 0;
  let startY = 0;
  let startScrollLeft = 0;
  let dragged = false;
  let suppressClick = false;
  let suppressClickTimer = null;

  function getPoint(event) {
    const touch = event.changedTouches?.[0] || event.touches?.[0];
    if (touch) return { x: touch.clientX, y: touch.clientY };
    return { x: event.clientX, y: event.clientY };
  }

  function onStart(event) {
    if (event.type.startsWith('touch') && window.PointerEvent) return;
    const rail = event.target.closest?.(
      '.cart-essentials__track, .predictive-search-results__list'
    );
    if (!rail) return;

    const point = getPoint(event);
    activeRail = rail;
    activePointerId = event.pointerId ?? null;
    startX = point.x;
    startY = point.y;
    startScrollLeft = rail.scrollLeft;
    dragged = false;
  }

  function onMove(event) {
    if (!activeRail) return;
    if (activePointerId !== null && event.pointerId !== activePointerId) return;

    const point = getPoint(event);
    const deltaX = point.x - startX;
    const deltaY = point.y - startY;
    const absX = Math.abs(deltaX);
    const absY = Math.abs(deltaY);

    if (!dragged) {
      if (absY > absX + 5) {
        activeRail = null;
        return;
      }

      if (absX < 6 || absX < absY + 2) return;
    }

    dragged = true;
    suppressClick = true;
    window.clearTimeout(suppressClickTimer);
    suppressClickTimer = window.setTimeout(() => {
      suppressClick = false;
    }, 350);
    activeRail.scrollLeft = startScrollLeft - deltaX;
    event.preventDefault();
  }

  function onEnd(event) {
    if (activePointerId !== null && event?.pointerId !== activePointerId) return;
    activeRail = null;
    activePointerId = null;
    dragged = false;
  }

  function onClick(event) {
    if (!suppressClick) return;
    event.preventDefault();
    event.stopPropagation();
    suppressClick = false;
    window.clearTimeout(suppressClickTimer);
  }

  document.addEventListener('pointerdown', onStart, { capture: true, passive: true });
  document.addEventListener('pointermove', onMove, { capture: true, passive: false });
  document.addEventListener('pointerup', onEnd, { capture: true, passive: true });
  document.addEventListener('pointercancel', onEnd, { capture: true, passive: true });
  if (!window.PointerEvent) {
    document.addEventListener('touchstart', onStart, { capture: true, passive: true });
    document.addEventListener('touchmove', onMove, { capture: true, passive: false });
    document.addEventListener('touchend', onEnd, { capture: true, passive: true });
    document.addEventListener('touchcancel', onEnd, { capture: true, passive: true });
  }
  document.addEventListener('click', onClick, { capture: true });

  return { onStart, onMove, onEnd };
})();

class AnnouncementBar extends HTMLElement {
  constructor(){
    super();

    this.items = Array.from(this.querySelectorAll('.announcement-bar__content li'));
    this.delay = this.dataset.interval;
    this.currentItemIndex = 0;

    // Run the animation if there are more than 1 announcement
    if (this.items.length > 1) {
      this.switchItems();
    }
  }

  connectedCallback() {
    this.setAttribute('role', 'alert');
    this.setAttribute('aria-live', 'assertive');
    this.toggleVisuallyHidden();
  }

  switchItems() {
    setInterval(() => {
      this.toggleVisuallyHidden();
      window.app.calcHeaderAnnouncementBarHeight();
    }, this.delay); 
  }

  toggleVisuallyHidden() {
    this.items.forEach((item, index) => {
      if (index === this.currentItemIndex) {
        item.classList.remove('visually-hidden');
        item.setAttribute('aria-hidden', 'false');
      } else {
        item.classList.add('visually-hidden');
        item.setAttribute('aria-hidden', 'true');
      }
    });
    this.currentItemIndex = (this.currentItemIndex + 1) % this.items.length;
  }
}

customElements.define("announcement-bar", AnnouncementBar);

class DropdownLink extends HTMLElement {
  constructor() {
      super();
  }

  connectedCallback() {
      this.href = this.getAttribute('href');
      this.current = this.getAttribute('data-current') === 'true';
      this.anchor = this.querySelector('a');
      this.anchor.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
      event.preventDefault();

      const parentElement = this.closest('li');
      const headerDropdown = parentElement.querySelector('.header__dropdown');

      const previousDropdowns = document.querySelectorAll('.header__dropdown.open');
      previousDropdowns.forEach((dropdown) => dropdown.classList.remove('open'));

      headerDropdown.classList.add('open');

      headerDropdown.addEventListener('focusin', (event) => event.stopPropagation());
      headerDropdown.addEventListener('focusout', () => {
          setTimeout(() => headerDropdown.classList.remove('open'), 0);
      });

      document.addEventListener('click', (event) => {
          const target = event.target;
          if (!this.contains(target) && !headerDropdown.contains(target)) {
              headerDropdown.classList.remove('open');
          }
      });
  }
}

customElements.define('dropdown-link', DropdownLink);
class HeaderDrawer extends HTMLElement {
  constructor() {
    super();

    this.hamburgerIcon = this.querySelector('#MenuDrawer-HamburgerIcon');
    this.closeIcon = this.querySelector('#MenuDrawer-CloseIcon');
    this.drawer = this.querySelector('#MenuDrawer');
    this.drawerInner = this.querySelector('.menu-drawer__wrapper');
    this.isAnimating = false;

    this.animate = gsap.timeline({
      paused: true,
      reversed: true,
    });

    this.animation();
    this.resetClosedState();
    this.eventListeners();
  }

  toggle(event) {
    event?.preventDefault();
    if (this.isAnimating) return;

    if (this.isDrawerOpen || document.body.classList.contains('menu-drawer-open')) {
      this.closeDrawer();
    } else {
      this.openDrawer();
    }
  }

  animation() {
    this.animate.fromTo(this.drawer, {
      display: 'none',
      autoAlpha: 0,
      y: -6,
    }, {
      display: 'block',
      autoAlpha: 1,
      y: 0,
      duration: 0.58,
      ease: 'power2.out',
    });
  }

  resetClosedState() {
    this.isDrawerOpen = false;
    this.isAnimating = false;
    this.closeIcon.style.display = 'none';
    this.hamburgerIcon.style.display = 'inline-flex';
    document.body.classList.remove('menu-drawer-open', 'overflow-hidden');
    if (window.SkinNoteDrawers) window.SkinNoteDrawers.unlock('menu');
    gsap.set(this.drawer, {
      display: 'none',
      autoAlpha: 0,
      y: -6,
    });
  }

  openDrawer() {
    this.isAnimating = true;
    this.showDrawer();
    this.animate.eventCallback('onComplete', () => {
      this.isDrawerOpen = true;
      this.isAnimating = false;
    });
    this.animate.play(0);
  }

  closeDrawer() {
    if (!this.isDrawerOpen && !document.body.classList.contains('menu-drawer-open')) return;

    this.isAnimating = true;
    this.isDrawerOpen = false;
    this.closeIcon.style.display = 'none';
    this.hamburgerIcon.style.display = 'inline-flex';
    removeTrapFocus();

    this.animate.eventCallback('onReverseComplete', () => {
      this.resetClosedState();
      this.isAnimating = false;
    });
    this.animate.reverse();
  }

  showDrawer() {
    this.isDrawerOpen = true;

    if (window.SkinNoteSearchModal?.isOpen || document.body.classList.contains('search-modal-open')) {
      window.SkinNoteSearchModal?.close?.(true);
    }

    const cartDrawer = document.querySelector('cart-drawer.open');
    if (cartDrawer) {
      cartDrawer.close?.();
      cartDrawer.classList.remove('open');
      cartDrawer.style.visibility = 'hidden';
      document.body.classList.remove('cart-drawer-open', 'overflow-hidden');
      if (window.SkinNoteDrawers) window.SkinNoteDrawers.unlock('cart');
    }

    if (window.SkinNoteDrawers) window.SkinNoteDrawers.lock('menu');
    document.body.classList.add('menu-drawer-open', 'overflow-hidden');
    this.closeIcon.style.display = 'inline-flex';
    this.hamburgerIcon.style.display = 'none';

    const containerToTrapFocus = this.drawer;
    const focusElement = this.drawerInner || this.closeIcon;
    trapFocus(containerToTrapFocus, focusElement);
  }

  hideDrawer() {
    this.closeDrawer();
  }

  eventListeners() {
    this.hamburgerIcon.addEventListener('click', this.toggle.bind(this));
    this.closeIcon.addEventListener('click', (event) => {
      event.preventDefault();
      this.closeDrawer();
    });

    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        this.closeDrawer();
      }
    });
  }
}

customElements.define('header-drawer', HeaderDrawer);

if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
      this.hidePanel();
      event.stopPropagation();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const isChild = this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
      if (!event.relatedTarget || !isChild) {
        this.hidePanel();
      }
    }
  });
}

class MarqueeItem extends HTMLElement {
  constructor() {
    super();

    this.dataset.clone = this.dataset.clone || 3;
    this.initialized = false;
    this.resizeObserver = null;
    this.resizeTimer = null;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.waitForImages().then(() => {
      this.buildTrack();
      requestAnimationFrame(() => this.animate());
    });
  }

  disconnectedCallback() {
    window.clearTimeout(this.resizeTimer);
    this.resizeObserver?.disconnect();
  }

  waitForImages() {
    const images = Array.from(this.querySelectorAll('img'));
    if (!images.length) return Promise.resolve();

    return Promise.all(images.map((image) => {
      if (image.complete && image.naturalWidth > 0) return Promise.resolve();
      if (image.decode) return image.decode().catch(() => {});

      return new Promise((resolve) => {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', resolve, { once: true });
      });
    }));
  }

  buildTrack() {
    if (this.querySelector(':scope > .marquee-item__track')) return;

    const source = this.querySelector(':scope > div:not([aria-hidden="true"])') || this.querySelector(':scope > div');
    if (!source) return;

    const set = document.createElement('div');
    set.className = 'marquee-item__set';
    set.innerHTML = source.innerHTML;

    source.replaceWith(set);

    const minimumWidth = (this.clientWidth || window.innerWidth || 390) * 1.35;
    const originalChildren = Array.from(set.children).map((child) => child.cloneNode(true));
    let guard = 0;

    while (set.scrollWidth < minimumWidth && originalChildren.length && guard < 8) {
      originalChildren.forEach((child) => set.appendChild(child.cloneNode(true)));
      guard += 1;
    }

    const clone = set.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');

    const track = document.createElement('div');
    track.className = 'marquee-item__track';
    track.append(set, clone);
    this.appendChild(track);
  }

  animate() {
    const track = this.querySelector(':scope > .marquee-item__track');
    const set = this.querySelector(':scope > .marquee-item__track > .marquee-item__set');
    if (!track || !set) return;

    const speed = Math.max(1, parseFloat(this.dataset.speed) || 30);
    const distance = Math.max(1, set.scrollWidth || set.getBoundingClientRect().width || 1);

    this.style.setProperty('--marquee-distance', `${distance}px`);
    this.style.setProperty('--marquee-duration', `${speed}s`);
    this.classList.toggle('is-reversed', this.dataset.reverse === 'true');
    this.classList.add('is-ready');

    if (!this.resizeObserver && 'ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => {
        window.clearTimeout(this.resizeTimer);
        this.resizeTimer = window.setTimeout(() => this.animate(), 120);
      });
      this.resizeObserver.observe(set);
      this.resizeObserver.observe(this);
    }
  }
}

customElements.define('marquee-item', MarqueeItem);

window.SkinNoteRecommendationsRail = window.SkinNoteRecommendationsRail || (() => {
  function getRail(button) {
    const targetId = button?.getAttribute('aria-controls');
    return targetId ? document.getElementById(targetId) : null;
  }

  function syncRail(rail) {
    if (!rail) return;
    const wrapper = rail.closest('product-recommendations');
    const prev = wrapper?.querySelector('[data-recommendations-rail-prev]');
    const next = wrapper?.querySelector('[data-recommendations-rail-next]');
    const canScroll = rail.scrollWidth > rail.clientWidth + 4;

    if (prev) prev.disabled = !canScroll || rail.scrollLeft <= 2;
    if (next) next.disabled = !canScroll || rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
  }

  function scrollRail(button, direction) {
    const rail = getRail(button);
    if (!rail) return;

    const firstItem = rail.querySelector(':scope > *');
    const styles = getComputedStyle(rail);
    const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
    const step = firstItem ? firstItem.getBoundingClientRect().width + gap : rail.clientWidth * 0.86;

    rail.scrollBy({
      left: step * direction,
      behavior: 'smooth'
    });
    window.setTimeout(() => syncRail(rail), 280);
  }

  function bind(root = document) {
    root.querySelectorAll?.('product-recommendations ul[id^="ProductRecommendationsRail-"]').forEach((rail) => {
      if (rail.dataset.recommendationsRailReady === 'true') {
        syncRail(rail);
        return;
      }

      rail.dataset.recommendationsRailReady = 'true';
      rail.addEventListener('scroll', () => syncRail(rail), { passive: true });
      requestAnimationFrame(() => syncRail(rail));
    });
  }

  document.addEventListener('click', (event) => {
    const prev = event.target.closest?.('[data-recommendations-rail-prev]');
    const next = event.target.closest?.('[data-recommendations-rail-next]');
    if (!prev && !next) return;

    event.preventDefault();
    scrollRail(prev || next, prev ? -1 : 1);
  });

  document.addEventListener('DOMContentLoaded', () => bind());

  if ('MutationObserver' in window) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) bind(node);
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  return { bind, syncRail };
})();

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');

    this.changeEvent = new Event('change', { bubbles: true })
    this.quantityUpdateEvent = new CustomEvent(PUB_SUB_EVENTS.quantityUpdate, {
      bubbles: true,
      detail: { value: 0 },
    });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

    this.lockManualInput();
    this.validateQtyRules(parseInt(this.input.value));
  }

  onButtonClick(event) {
    event.preventDefault();
    if (this.classList.contains('is-updating')) return;

    const previousValue = this.input.value;
    const direction = event.target.name === 'plus' ? 1 : -1;
    const result = this.stepQuantity(direction);

    if (result.hitLimit) {
      this.showLimitError();
    } else if (direction < 0) {
      this.clearLimitError();
    }

    if (previousValue !== this.input.value) {
      if (this.shouldLockControls()) this.lockControls();
      this.updateQuantity();
    }
  }

  shouldLockControls() {
    return Boolean(this.input?.dataset.index && this.closest('cart-form, cart-drawer-content'));
  }

  lockControls() {
    this.classList.add('is-updating');
    this.querySelectorAll('button').forEach((button) => {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    });

    window.clearTimeout(this.unlockTimer);
    this.unlockTimer = window.setTimeout(() => this.unlockControls(), 3500);
  }

  unlockControls() {
    window.clearTimeout(this.unlockTimer);
    this.classList.remove('is-updating');
    this.querySelectorAll('button').forEach((button) => {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
    });
  }

  lockManualInput() {
    if (!this.input) return;

    this.input.readOnly = true;
    this.input.setAttribute('readonly', '');
    this.input.setAttribute('aria-readonly', 'true');
    this.input.setAttribute('inputmode', 'none');
    this.input.setAttribute('autocomplete', 'off');
    this.input.classList.add('quantity__input--locked');

    this.input.addEventListener('beforeinput', (event) => event.preventDefault());
    this.input.addEventListener('paste', (event) => event.preventDefault());
    this.input.addEventListener('drop', (event) => event.preventDefault());
    this.input.addEventListener('wheel', (event) => {
      event.preventDefault();
      this.input.blur();
    }, { passive: false });
    this.input.addEventListener('keydown', (event) => {
      const allowedKeys = ['Tab', 'Shift', 'Escape'];
      if (allowedKeys.includes(event.key)) return;
      event.preventDefault();
    });
  }

  getStep() {
    const step = parseInt(this.input.step);
    return Number.isFinite(step) && step > 0 ? step : 1;
  }

  getCurrentValue() {
    const value = parseInt(this.input.value);
    const min = parseInt(this.input.min);

    if (Number.isFinite(value)) return value;
    if (Number.isFinite(min)) return min;
    return 1;
  }

  getEffectiveMax() {
    const nativeMax = parseInt(this.input.max);
    const limitMax = window.SkinNoteCartLimit?.maxPerVariant;
    const maxValues = [];

    if (Number.isFinite(nativeMax)) maxValues.push(nativeMax);
    if (Number.isFinite(limitMax)) maxValues.push(limitMax);

    return maxValues.length ? Math.min(...maxValues) : undefined;
  }

  showLimitError() {
    const message = window.SkinNoteCartLimit?.message?.(this.getEffectiveMax()) || '';
    if (!message) return;

    const line = this.input.dataset.index;
    const cartForm = this.closest('cart-form, cart-drawer-content');
    if (line && typeof cartForm?.updateLiveRegions === 'function') {
      cartForm.updateLiveRegions(line, message);
      return;
    }

    const productForm = this.closest('product-form');
    if (typeof productForm?.handleErrorMessage === 'function') {
      productForm.handleErrorMessage(message);
      return;
    }

    window.SkinNoteCartLimit?.showInlineError?.(this, message);
  }

  clearLimitError() {
    const line = this.input.dataset.index;
    const cartForm = this.closest('cart-form, cart-drawer-content');
    if (line && typeof cartForm?.updateLiveRegions === 'function') {
      cartForm.updateLiveRegions(line, '');
      return;
    }

    const productForm = this.closest('product-form');
    productForm?.handleErrorMessage?.();
  }

  stepQuantity(direction) {
    const step = this.getStep();
    const min = parseInt(this.input.min);
    const max = this.getEffectiveMax();
    const currentValue = this.getCurrentValue();
    let nextValue = this.getCurrentValue() + (step * direction);
    let hitLimit = false;

    if (Number.isFinite(min)) nextValue = Math.max(min, nextValue);
    if (Number.isFinite(max) && nextValue > max) {
      nextValue = max;
      hitLimit = direction > 0 && currentValue >= max;
    }

    this.input.value = nextValue;
    return { hitLimit };
  }

  updateQuantity() {
    const value = parseInt(this.input.value);
    this.validateQtyRules(value);

    this.input.dispatchEvent(this.changeEvent);
    this.quantityUpdateEvent.detail.value = value;
    this.dispatchEvent(this.quantityUpdateEvent);
  }

  validateQtyRules(value) {
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = this.getEffectiveMax();
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', Number.isFinite(max) && value >= max);
    } else {
      const max = this.getEffectiveMax();
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      if (buttonPlus) buttonPlus.classList.toggle('disabled', Number.isFinite(max) && value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);


class BackgroundVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video');
    this.toggleSoundButton = this.querySelector('.toggle-sound');

    this.soundOnLabel = this.dataset.soundOnLabel;
    this.soundOffLabel = this.dataset.soundOffLabel;

    this.eventListeners();
  }

  isInViewport() {
    const rect = this.getBoundingClientRect();
    return (
      (rect.top >= 0 && rect.top <= window.innerHeight) ||
      (rect.bottom >= 0 && rect.bottom <= window.innerHeight)
    );
  }

  onToggleSound() {
    this.video.muted = !this.video.muted;
    this.toggleSoundButton.innerHTML = this.video.muted ? this.soundOnLabel : this.soundOffLabel;
    this.toggleSoundButton.setAttribute('aria-pressed', !this.video.muted);
  }

  onScroll() {
    if (this.isInViewport()) {
      this.video.play();
    } else {
      this.video.pause();
    }
  }

  eventListeners() {
    this.toggleSoundButton ? this.toggleSoundButton.addEventListener('click', this.onToggleSound.bind(this)) : null;
    this.toggleSoundButton ? this.toggleSoundButton.addEventListener('keydown', (e) => {
      if (e.keyCode === 13) {
        this.onToggleSound();
      }
    }) : null;

    window.addEventListener('scroll', debounce(this.onScroll.bind(this), 100));
  }
}
customElements.define('background-video', BackgroundVideo);


class ImageComparisonSlider extends HTMLElement {
  connectedCallback() {
    this.imageComparisonSlider = this.querySelector('[data-image-comparison-slider]');
    this.sliderRange = this.querySelector('[data-image-comparison-range]');
    this.imageComparisonOverlay = this.querySelector('[data-image-comparison-overlay]');

    this.initSlider();
    this.eventListeners();
  }

  initSlider() {
    this.updateSlider();
    this.setImageWidth();
  }

  updateSlider() {
    const sliderValue = this.sliderRange.value;
    const isRTL = window.app && typeof window.app.isRTL !== 'undefined' ? window.app.isRTL : false;

    gsap.set(this.imageComparisonOverlay, {
      width: `${sliderValue}%`
    });

    gsap.set(this.imageComparisonSlider, {
      left: isRTL ? `${sliderValue}%` : `${100 - sliderValue}%`
    });
  }

  setImageWidth() {
    const figure = this.imageComparisonOverlay.querySelector('figure');
    figure.style.width = `${this.getElementContentWidth(this)}px`;
  }

  getElementContentWidth(element) {
    const styles = window.getComputedStyle(element);
    const padding = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
    return element.clientWidth - padding;
  }

  eventListeners() {
    this.sliderRange.addEventListener('input', (e) => {
      this.moveSliderRange(e.target.value);
    });

    this.sliderRange.addEventListener('change', (e) => {
      this.moveSliderRange(e.target.value);
    });

    window.addEventListener('resize', () => {
      this.onResize();
    });

    // Observe changes to the custom element
    const observer = new MutationObserver(() => {
      this.initSlider();
    });
    observer.observe(this, { attributes: true, childList: true, subtree: true });
  }

  onResize() {
    this.setImageWidth();
    this.updateSlider();
  }

  moveSliderRange(value) {
    const isRTL = window.app && typeof window.app.isRTL !== 'undefined' ? window.app.isRTL : false;

    gsap.to(this.imageComparisonSlider, {
      left: isRTL ? `${100 - value}%` : `${value}%`,
      duration: 0.3,
      ease: 'power2.out'
    });

    gsap.to(this.imageComparisonOverlay, {
      width: `${value}%`,
      duration: 0.3,
      ease: 'power2.out'
    });
  }
}

customElements.define('image-comparison-slider', ImageComparisonSlider);


class passwordVisibility extends HTMLElement {
  constructor() {
    super();

    this.passwordInput = this.querySelector('input');
    this.togglePasswordButton = this.querySelector('button');
    this.togglePasswordButtonSpans = this.querySelectorAll('button > span');
    this.togglePasswordButton.addEventListener('click', this.togglePasswordVisibility.bind(this));
  }

  togglePasswordVisibility(e) {
    e.preventDefault();
    if (this.passwordInput.type === 'password') {
      this.passwordInput.type = 'text';
      this.togglePasswordButton.setAttribute('aria-pressed', 'true');
      this.togglePasswordButtonSpans[0].classList.add('visually-hidden');
      this.togglePasswordButtonSpans[1].classList.remove('visually-hidden');
    } else {
      this.passwordInput.type = 'password';
      this.togglePasswordButton.setAttribute('aria-pressed', 'false');
      this.togglePasswordButtonSpans[0].classList.remove('visually-hidden');
      this.togglePasswordButtonSpans[1].classList.add('visually-hidden');
    }
  }
}

customElements.define('password-visibility', passwordVisibility);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateVariantId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }

    if (!this.currentVariant) return;
    this.dispatchEvent(
      new CustomEvent(PUB_SUB_EVENTS.variantChange, {
        bubbles: true,
        detail: { currentVariant: this.currentVariant, sectionId: this.currentVariant.id },
      })
    );
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateVariantId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
      
      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const quickAddModal = this.closest('quick-add-modal');
    if (quickAddModal) {
      this.updateQuickAddMedia(quickAddModal);
      return;
    }

    const media = document.getElementById(`ProductMedia-${this.dataset.section}`);
    const currentMedia = media.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    media.slider.selectCell(currentMedia);
  }

  getSizedImageUrl(src, width) {
    if (!src) return '';

    const normalizedSrc = src.startsWith('//') ? `${window.location.protocol}${src}` : src;

    try {
      const url = new URL(normalizedSrc, window.location.origin);
      url.searchParams.set('width', width);
      return url.toString();
    } catch (error) {
      return normalizedSrc;
    }
  }

  updateQuickAddMedia(quickAddModal) {
    const image = quickAddModal.querySelector('[data-quick-add-media-image]');
    const previewImage = this.currentVariant.featured_media?.preview_image || this.currentVariant.featured_media;
    const src = previewImage?.src;

    if (!image || !src) return;

    const width = previewImage.width || this.currentVariant.featured_media.width || image.width || 533;
    const height = previewImage.height || this.currentVariant.featured_media.height || image.height || width;
    const widths = [165, 360, 533, 720, 940, 1066].filter((candidate) => candidate <= width);
    const imageSrc = this.getSizedImageUrl(src, Math.min(533, width));
    const imageSrcset = [
      ...widths.map((candidate) => `${this.getSizedImageUrl(src, candidate)} ${candidate}w`),
      `${this.getSizedImageUrl(src, width)} ${width}w`
    ].join(', ');
    const imageAlt = this.currentVariant.featured_media.alt || image.alt || '';

    if (image.currentSrc === imageSrc || image.src === imageSrc) {
      image.alt = imageAlt;
      return;
    }

    const nextImage = new Image();
    nextImage.decoding = 'async';
    nextImage.srcset = imageSrcset;
    nextImage.src = imageSrc;
    nextImage.alt = imageAlt;

    const swapImage = () => {
      image.srcset = imageSrcset;
      image.src = imageSrc;
      image.alt = imageAlt;
      image.width = width;
      image.height = height;
    };

    if (nextImage.decode) {
      nextImage.decode().then(swapImage).catch(swapImage);
    } else {
      nextImage.onload = swapImage;
      nextImage.onerror = swapImage;
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms =
      document.querySelectorAll(`#Product-Form-${this.dataset.section}, #Product-Form-Installment-${this.dataset.section}`);

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  formatQuickAddMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';
    const locale = document.documentElement.lang || 'en-US';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      }).format((cents || 0) / 100);
    } catch (error) {
      return `$${((cents || 0) / 100).toFixed(2)}`;
    }
  }

  renderQuickAddProductInfo() {
    if (!this.closest('quick-add-modal') || !this.currentVariant) return false;

    const price = document.getElementById(`Price-${this.dataset.section}`);
    if (!price) return false;

    const compareAtPrice = this.currentVariant.compare_at_price;
    const variantPrice = this.currentVariant.price;
    const isOnSale = compareAtPrice && compareAtPrice > variantPrice;
    const isAvailable = this.currentVariant.available;
    const moneyPrice = this.formatQuickAddMoney(variantPrice);
    const moneyCompareAtPrice = this.formatQuickAddMoney(compareAtPrice);

    price.innerHTML = `
      <div class="price price__container${!isAvailable ? ' price--sold-out' : ''}${isOnSale ? ' price--on-sale' : ''}">
        <div class="price__wrapper">
          <div class="price__regular">
            <span class="visually-hidden">Regular price</span>
            <span class="price-item price-item--regular">${moneyPrice}</span>
          </div>
          <div class="price__sale">
            <span class="visually-hidden">Regular price</span>
            <span>
              <s class="price-item price-item--regular">${moneyCompareAtPrice}</s>
            </span>
            <span class="visually-hidden">Sale price</span>
            <span class="price-item price-item--sale">${moneyPrice}</span>
          </div>
        </div>
      </div>
    `;
    price.classList.remove('visibility-hidden');
    this.toggleAddButton(!isAvailable, window.variantStrings.soldOut);

    return true;
  }

  renderProductInfo() {
    if (this.renderQuickAddProductInfo()) return;

    const requestedVariantId = this.currentVariant.id;

    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`Price-${this.dataset.section}`);
        const source = html.getElementById(`Price-${this.dataset.section}`);

        const stickyPriceDestination = document.getElementById(`StickyPrice-${this.dataset.section}`);
        const stickyPriceSource = html.getElementById(`StickyPrice-${this.dataset.section}`);

        const stickyAddToCartDestination = document.getElementById(`StickyAddToCart-${this.dataset.section}`);
        const stickyAddToCartSource = html.getElementById(`StickyAddToCart-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (stickyPriceSource && stickyPriceDestination) stickyPriceDestination.innerHTML = stickyPriceSource.innerHTML;
        if (stickyAddToCartSource && stickyAddToCartDestination) stickyAddToCartDestination.innerHTML = stickyAddToCartSource.innerHTML;

        const price = document.getElementById(`Price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text) {
    const productForm = document.getElementById(`Product-Form-${this.dataset.section}`);
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const stickyAddButton = document.getElementById(`StickyAddToCart-${this.dataset.section}`);
    const stickyAddButtonText = stickyAddButton?.querySelector('span');
    const isPreorder = addButton.dataset.isPreorder === "true";

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      stickyAddButton?.setAttribute('disabled', 'disabled');
      if (text && stickyAddButtonText) stickyAddButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.removeAttribute('aria-disabled');
      addButtonText.textContent = isPreorder ? window.variantStrings.preOrder : window.variantStrings.addToCart;
      stickyAddButton?.removeAttribute('disabled');
      stickyAddButton?.removeAttribute('aria-disabled');
      if (stickyAddButtonText) stickyAddButtonText.textContent = isPreorder ? window.variantStrings.preOrder : window.variantStrings.addToCart;
    }
  }

  setUnavailable() {
    const button = document.getElementById(`Product-Form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`Price-${this.dataset.section}`);

    if (!addButton) return;

    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
      pickUpAvailability.removeAttribute('available');
    } else {
      pickUpAvailability.innerHTML = '';
    }
  }
};
customElements.define('variant-selects', VariantSelects);


if (window.theme && window.theme.enablePredictiveSearch) {
  class SearchModal {
    constructor() {
      this.el = document.querySelector('.search-modal__container');

      if (!this.el) {
        return; // Exit constructor if the main element doesn't exist
      }

      window.SkinNoteSearchModal = this;
      this.el.SkinNoteSearchModal = this;

      this.elements = {
        searchIcon: document.querySelector('header .header__icon--search'),
        searchInput: this.el.querySelector('input[type="search"]'),
        searchModalWrapper: this.el.querySelector('.search-modal__wrapper'),
        searchModalOverlay: this.el.querySelector('.search-modal__overlay'),
        searchModalCloseBtn: this.el.querySelector('.search-modal__close-btn'),
        searchDefaultState: this.el.querySelector('.search-modal__default-state'),
        searchPredictiveResults: this.el.querySelector('[data-predictive-search]'),
        searchRailControls: this.el.querySelector('.search-modal__rail-controls'),
        searchRailPrev: this.el.querySelector('[data-search-rail-prev]'),
        searchRailNext: this.el.querySelector('[data-search-rail-next]'),
        searchFeaturedKeywords: this.el.querySelectorAll('[data-featured-keyword]'),
      }

      this.elements.searchModalWrapper?.setAttribute('tabindex', '-1');
      this.cachedSearchResults = {};
      this.isOpen = false;
      this.focusReturnElement = null;
      this.openScrollY = 0;
      this.searchPlaceholderTyping = {
        hasPlayed: false,
        text: '',
        timer: null,
      };

      const timeline = gsap.timeline({
        ease: "power3.out",
        paused: true,
        reversed: true,
        onStart: () => {
          this.el.removeAttribute('hidden');
          this.elements.searchIcon?.setAttribute('aria-expanded', 'true');
        },
        onReverseComplete: () => {
          setTimeout(() => {
            this.el.setAttribute('hidden', '');
            this.elements.searchIcon?.setAttribute('aria-expanded', 'false');
          }, 100);
        }
      });
      this.tl = timeline;

      this.animate();
      this.setupSearchPlaceholderTyping();
      this.eventListeners();
    }

    animate() {
      this.tl.from(this.elements.searchModalOverlay, {
        autoAlpha: 0,
        duration: 0.16,
      }, 0)
        .fromTo(this.elements.searchModalWrapper, {
          autoAlpha: 0,
          y: -10,
        }, {
          autoAlpha: 1,
          y: 0,
          duration: 0.34,
          ease: "power2.out"
        }, 0)
    }

    open() {
      if (this.isOpen) return;
      this.openScrollY = window.scrollY || window.pageYOffset || 0;
      this.focusReturnElement = document.activeElement;
      const headerDrawer = document.querySelector('header-drawer');
      if (headerDrawer?.isDrawerOpen || document.body.classList.contains('menu-drawer-open')) {
        headerDrawer.hideDrawer?.();
      }

      const cartDrawer = document.querySelector('cart-drawer.open');
      if (cartDrawer) cartDrawer.close?.();

      this.isOpen = true;
      if (window.SkinNoteDrawers) window.SkinNoteDrawers.lock('search');
      this.openScrollY = window.SkinNoteDrawers?.getScrollY?.() ?? this.openScrollY;
      document.body.classList.add('search-modal-open', 'overflow-hidden');
      this.tl.play();
      this.playSearchPlaceholderTyping();
      this.tl.then(() => {
        if (!this.isOpen) return;
        const containerToTrapFocus = this.el;
        const shouldAutofocusInput = !window.matchMedia('(max-width: 59.99em)').matches;
        const focusElement = shouldAutofocusInput ? this.elements.searchInput : this.elements.searchModalWrapper;
        trapFocus(containerToTrapFocus, focusElement);
      });
    }

    close(immediate = false) {
      if (!this.isOpen && this.tl.reversed()) return;
      this.isOpen = false;

      if (this.el.contains(document.activeElement)) {
        document.activeElement.blur();
      }

      this.stopSearchPlaceholderTyping(true);
      removeTrapFocus();
      if (immediate) {
        this.tl.pause(0);
        this.el.setAttribute('hidden', '');
        this.elements.searchIcon?.setAttribute('aria-expanded', 'false');
      } else {
        this.tl.reverse();
      }
      document.body.classList.remove('search-modal-open', 'overflow-hidden');
      if (window.SkinNoteDrawers) window.SkinNoteDrawers.unlock('search');
      window.SkinNoteDrawers?.restoreScroll?.(14);
      this.restoreOpenScroll(14);

      const isMobile = window.matchMedia('(max-width: 59.99em)').matches;
      if (!isMobile && this.focusReturnElement?.focus) {
        try {
          this.focusReturnElement.focus({ preventScroll: true });
        } catch (error) {
          this.focusReturnElement.focus();
        }
      }
    }

    restoreOpenScroll(attempts = 8) {
      const targetY = this.openScrollY || 0;
      let count = 0;

      const restore = () => {
        window.scrollTo(0, targetY);
        count += 1;

        if (count < attempts) {
          requestAnimationFrame(restore);
        }
      };

      requestAnimationFrame(restore);
    }

    setupSearchPlaceholderTyping() {
      const input = this.elements.searchInput;
      if (!input || !input.matches('[data-skn-typing-placeholder]')) return;

      const text = input.getAttribute('placeholder') || '';
      if (!text.trim()) return;

      this.searchPlaceholderTyping.text = text;
      input.dataset.sknTypingPlaceholderText = text;
    }

    stopSearchPlaceholderTyping(showFullPlaceholder = false) {
      const input = this.elements.searchInput;
      const state = this.searchPlaceholderTyping;
      if (!input || !state) return;

      window.clearTimeout(state.timer);
      state.timer = null;
      input.classList.remove('is-placeholder-typing');
      input.classList.remove('is-placeholder-typed');

      if (showFullPlaceholder && state.text) {
        input.setAttribute('placeholder', state.text);
        if (!input.value.trim()) {
          input.classList.add('is-placeholder-typed');
        }
      }
    }

    playSearchPlaceholderTyping() {
      const input = this.elements.searchInput;
      const state = this.searchPlaceholderTyping;
      if (!input || !state?.text || state.hasPlayed || input.value.trim()) return;

      state.hasPlayed = true;
      window.clearTimeout(state.timer);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        input.setAttribute('placeholder', state.text);
        input.classList.add('is-placeholder-typed');
        return;
      }

      input.classList.remove('is-placeholder-typed');
      input.classList.add('is-placeholder-typing');
      input.setAttribute('placeholder', '');

      let index = 0;
      const typeNext = () => {
        if (!this.isOpen) {
          this.stopSearchPlaceholderTyping(true);
          return;
        }

        if (input.value.trim()) {
          this.stopSearchPlaceholderTyping(true);
          return;
        }

        index += 1;
        input.setAttribute('placeholder', state.text.slice(0, index));

        if (index < state.text.length) {
          const currentCharacter = state.text.charAt(index - 1);
          const delay = currentCharacter === ' ' ? 64 : 36;
          state.timer = window.setTimeout(typeNext, delay);
          return;
        }

        state.timer = null;
        input.classList.remove('is-placeholder-typing');
        input.classList.add('is-placeholder-typed');
      };

      state.timer = window.setTimeout(typeNext, 140);
    }

    toggle() {
      this.isOpen ? this.close() : this.open();
    }

    getQuery() {
      return this.elements.searchInput.value;
    }

    resetSearchState() {
      this.elements.searchDefaultState.removeAttribute('hidden');
      this.elements.searchDefaultState.classList.remove('visually-hidden');

      this.elements.searchPredictiveResults.setAttribute('hidden', '');
      this.elements.searchPredictiveResults.classList.add('visually-hidden');
      this.elements.searchPredictiveResults.innerHTML = '';
      this.hidePredictiveRailControls();
    }

    renderShortQueryState(searchTerm) {
      this.elements.searchDefaultState.removeAttribute('hidden');
      this.elements.searchDefaultState.classList.remove('visually-hidden');

      this.elements.searchPredictiveResults.innerHTML = `
        <div class="predictive-search-results predictive-search-results--short-query" role="status">
          <p class="predictive-search-results__hint">
            Keep typing for better matches. "${searchTerm.replace(/[&<>"']/g, (char) => ({
              '&': '&amp;',
              '<': '&lt;',
              '>': '&gt;',
              '"': '&quot;',
              "'": '&#39;'
            }[char]))}" is a little too broad.
          </p>
        </div>
      `;
      this.elements.searchPredictiveResults.removeAttribute('hidden');
      this.elements.searchPredictiveResults.classList.remove('visually-hidden');
      this.hidePredictiveRailControls();
    }

    onChange() {
      const searchTerm = this.getQuery().trim();

      if (!searchTerm.length) {
        this.resetSearchState();
        return;
      }

      if (searchTerm.length < 2) {
        this.renderShortQueryState(searchTerm);
        return;
      }

      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
      const queryKey = searchTerm.trim().replace(/\s+/g, "-").toLowerCase();

      if (this.cachedSearchResults[queryKey]) {
        this.renderSearchResults(this.cachedSearchResults[queryKey]);
        return;
      }

      const params = new URLSearchParams({
        q: searchTerm,
        section_id: 'predictive-search',
      });
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '10');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][unavailable_products]', 'last');
      params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,variants.sku');

      fetch(`${routes.predictive_search_url}?${params.toString()}`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.cachedSearchResults[queryKey] = resultsMarkup;
          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          throw error;
        })
    }

    renderSearchResults(resultsMarkup) {
      this.elements.searchDefaultState.setAttribute('hidden', '');
      this.elements.searchDefaultState.classList.add('visually-hidden');

      this.elements.searchPredictiveResults.innerHTML = resultsMarkup;

      this.elements.searchPredictiveResults.removeAttribute('hidden');
      this.elements.searchPredictiveResults.classList.remove('visually-hidden');
      this.bindPredictiveRailControls();
    }

    getPredictiveRail() {
      return this.elements.searchPredictiveResults?.querySelector('.predictive-search-results__list');
    }

    hidePredictiveRailControls() {
      this.elements.searchRailControls?.setAttribute('hidden', '');
    }

    syncPredictiveRailControls() {
      const rail = this.getPredictiveRail();
      const controls = this.elements.searchRailControls;
      if (!rail || !controls) return;

      const canScroll = rail.scrollWidth > rail.clientWidth + 4;
      controls.toggleAttribute('hidden', !canScroll);
      if (!canScroll) return;

      const atStart = rail.scrollLeft <= 2;
      const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      if (this.elements.searchRailPrev) this.elements.searchRailPrev.disabled = atStart;
      if (this.elements.searchRailNext) this.elements.searchRailNext.disabled = atEnd;
    }

    scrollPredictiveRail(direction) {
      const rail = this.getPredictiveRail();
      if (!rail) return;

      const firstItem = rail.querySelector(':scope > *');
      const styles = getComputedStyle(rail);
      const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
      const step = firstItem ? firstItem.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;

      rail.scrollBy({
        left: step * direction,
        behavior: 'smooth'
      });
      window.setTimeout(() => this.syncPredictiveRailControls(), 280);
    }

    bindPredictiveRailControls() {
      const rail = this.getPredictiveRail();
      if (!rail) {
        this.hidePredictiveRailControls();
        return;
      }

      if (rail.dataset.searchRailReady !== 'true') {
        rail.dataset.searchRailReady = 'true';
        rail.addEventListener('scroll', () => this.syncPredictiveRailControls(), { passive: true });
      }

      requestAnimationFrame(() => this.syncPredictiveRailControls());
    }

    onFormSubmit(event) {
      const query = this.getQuery().trim();

      if (!query.length) {
        event.preventDefault();
        return;
      }

      const form = event.currentTarget;
      if (!form?.querySelector('input[name="type"]')) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'type';
        input.value = 'product';
        form.appendChild(input);
      }
    }

    eventListeners() {
      this.elements.searchIcon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggle();
      }, { capture: true });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.isOpen) {
          this.close();
        }
      });

      this.elements.searchModalOverlay.addEventListener('click', () => {
        this.close();
      });

      this.elements.searchModalCloseBtn.addEventListener('click', () => {
        this.close();
      });

      this.elements.searchRailPrev?.addEventListener('click', () => {
        this.scrollPredictiveRail(-1);
      });

      this.elements.searchRailNext?.addEventListener('click', () => {
        this.scrollPredictiveRail(1);
      });

      if (this.elements.searchFeaturedKeywords) {
        this.elements.searchFeaturedKeywords.forEach((keyword) => {
          keyword.addEventListener('click', (e) => {
            e.preventDefault();
            const query = (keyword.dataset.searchQuery || keyword.textContent || '').trim();
            if (!query) return;

            const searchUrl = new URL(window.routes?.search_url || '/search', window.location.origin);
            searchUrl.searchParams.set('q', query);
            searchUrl.searchParams.set('type', 'product');
            searchUrl.searchParams.set('options[prefix]', 'last');
            window.location.href = searchUrl.toString();
          });
        });
      }

      const form = this.el.querySelector('form.search');
      form.addEventListener('submit', this.onFormSubmit.bind(this));

      this.elements.searchInput.addEventListener('input', () => {
        this.stopSearchPlaceholderTyping(true);
      });

      this.elements.searchInput.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
    }
  }
  new SearchModal();
}

class MulticolumnMedia extends HTMLElement {
  constructor() {
    super();

    this.multicolumnMedia = [...this.querySelectorAll('.multicolumn-media__item--media')];

    this.init();
  }

  init() {
    this.multicolumnMedia.forEach(container => {
      const video = container.querySelector('video');
      const playButton = container.querySelector('button');

      if (!video) return;

      playButton.addEventListener('click', () => {
        if (video.paused) {
          video.play();
          playButton.style.opacity = '0';
          playButton.setAttribute('aria-label', 'Pause the video');
          playButton.setAttribute('aria-pressed', 'true');
          playButton.setAttribute('aria-hidden', 'true');
        } else {
          video.pause();
          playButton.style.opacity = '1';
          playButton.setAttribute('aria-label', 'Play the video');
          playButton.setAttribute('aria-pressed', 'false');
          playButton.setAttribute('aria-hidden', 'false');
        }
      });

      video.addEventListener('ended', () => {
        playButton.style.opacity = '1';
        playButton.setAttribute('aria-label', 'Play the video');
        playButton.setAttribute('aria-pressed', 'false');
        playButton.setAttribute('aria-hidden', 'false');
      });
    });
  }
}

customElements.define('multicolumn-media', MulticolumnMedia);

class ProductStickyBar extends HTMLElement {
  constructor() {
    super();

    this.parent = this.closest('.product__container');
    this.buyButtons = this.parent?.querySelector('.product__buy-buttons');
    this.isInViewClass = 'product__sticky-bar--in-view';
    this.boundViewportHandler = this.updateViewportMetrics.bind(this);
    this.boundScrollHandler = this.onScrollHandler.bind(this);
    this.showOffsetRatio = 0.58;
    this.showOffsetMax = 520;
    this.mobileQuery = window.matchMedia('(max-width: 60em)');

    if (!this.parent || !this.buyButtons) {
      this.setAttribute('hidden', '');
      this.setAttribute('aria-hidden', 'true');
      return;
    }

    this.updateViewportMetrics();
    window.addEventListener('scroll', this.boundScrollHandler, { passive: true });
    window.addEventListener('resize', this.boundViewportHandler, { passive: true });
    window.visualViewport?.addEventListener('resize', this.boundViewportHandler, { passive: true });
    window.visualViewport?.addEventListener('scroll', this.boundViewportHandler, { passive: true });
  }

  updateViewportMetrics() {
    const viewport = window.visualViewport;
    const viewportHeight = viewport?.height || window.innerHeight || document.documentElement.clientHeight;
    const viewportTop = viewport?.offsetTop || 0;
    const viewportBottom = viewportTop + viewportHeight;
    const layoutViewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const bottomGap = Math.max(0, layoutViewportHeight - viewportBottom);

    this.style.setProperty('--skn-sticky-viewport-bottom-gap', '0px');
    this.style.setProperty('--skn-sticky-visual-viewport-height', `${Math.round(viewportHeight)}px`);
    this.style.setProperty('--skn-sticky-visual-bottom-gap', `${Math.round(bottomGap)}px`);
    this.onScrollHandler();
  }

  addInViewClass() {
    this.classList.add(this.isInViewClass);
    this.setAttribute('aria-hidden', 'false');
    setTimeout(() => {
      this.removeAttribute('hidden');
    }, 100);
  }

  removeInViewClass() {
    this.classList.remove(this.isInViewClass);
    this.setAttribute('aria-hidden', 'true');
    setTimeout(() => {
      this.setAttribute('hidden', '');
    }, 100);
  }


  onScrollHandler() {
    if (this.mobileQuery.matches) {
      this.removeInViewClass();
      return;
    }

    this.footer = document.querySelector('.shopify-section-footer');
    if (!this.footer) return;
    this.footerRect = this.footer.getBoundingClientRect();

    const viewport = window.visualViewport;
    const viewportHeight = viewport?.height || window.innerHeight || document.documentElement.clientHeight;
    const viewportTop = viewport?.offsetTop || 0;
    this.position = window.pageYOffset + viewportTop + viewportHeight;
    const buyButtonsRect = this.buyButtons.getBoundingClientRect();
    const activationOffset = Math.min(this.showOffsetMax, viewportHeight * this.showOffsetRatio);
    const hasPassedBuyButtons = buyButtonsRect.bottom < -activationOffset;

    if (this.position > this.footer.offsetTop) {
      this.removeInViewClass();
    } else if (hasPassedBuyButtons) {
      this.addInViewClass();
    } else {
      this.removeInViewClass();
    }
  }

  observeIntersection() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.removeInViewClass();
          this.isInView = true;
        } else {
          this.addInViewClass();
          this.isInView = false;
        }
      });
    });

    this.observer.observe(this.parent);
  }
}

customElements.define('product-sticky-bar', ProductStickyBar);

document.addEventListener('click', (event) => {
  const stickyButton = event.target.closest?.('[data-sticky-add-to-cart]');
  if (!stickyButton) return;

  event.preventDefault();
  if (stickyButton.disabled || stickyButton.getAttribute('aria-disabled') === 'true') return;

  const formId = stickyButton.getAttribute('data-target-form');
  const form = formId ? document.getElementById(formId) : null;
  const submitButton = form?.querySelector?.('[name="add"]');
  if (!form || !submitButton || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;

  stickyButton.setAttribute('aria-busy', 'true');
  stickyButton.classList.add('loading');
  submitButton.click();
}, { capture: true });

class CamaSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.element = this.querySelector('[data-slider]');
    this.mount(this.element);

    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          this.slider.reloadCells();
        }
      });
    });

    const config = { childList: true, subtree: true };
    observer.observe(this, config);
  }

  mount(node, options = {}) {
    this.slider = new Flickity(node, {
      draggable: '>1',
      cellAlign: 'center',
      contain: true,
      freeScroll: true,
      dragThreshold: 25,
      adaptiveHeight: false,
      // wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      ...options
    });
  }

  unMount() {
    this.slider.destroy();
  }
}

customElements.define('cama-slider', CamaSlider);


class ProductMedia extends HTMLElement {
  connectedCallback() {
    this.element = this.querySelector('[data-slider]');
    this.thumbnails = this.querySelector('[data-product-thumbnails]');
    this.elementNotDraggable = this.querySelector('[data-draggable=false]');
    this.mount(this.element, this.thumbnails);

    window.addEventListener('resize', () => {
      this.resizeSliders();
    });
  }

  resizeSliders() {
    setTimeout(() => {
      this.slider.resize();
      this.sliderNav.resize();
    }, 1);
  }

  getCurrentMediaType() {
    const selectedCell = this.slider.selectedCell;
    const mediaType = selectedCell.element.dataset.mediaType;
    this.element.dataset.currentMediaType = mediaType;
  }

  mount(node, nodeThumbnails, options = {}) {
    window.pauseAllMedia();

    this.slider = new Flickity(node, {
      draggable: false,
      cellAlign: 'center',
      contain: true,
      accessibility: true,
      freeScroll: false,
      adaptiveHeight: !window.matchMedia("(max-width: 60em)").matches,
      // wrapAround: true,
      // watchCSS: true,
      prevNextButtons: true,
      pageDots: false,
      ...options
    });

    this.sliderNav = new Flickity(nodeThumbnails, {
      asNavFor: node,
      cellAlign: 'center',
      accessibility: true,
      contain: true,
      pageDots: false,
      prevNextButtons: false,
    });

    this.getCurrentMediaType();

    this.slider.on('select', () => {
      this.getCurrentMediaType();
    });

    this.slider.on('change', () => {
      window.pauseAllMedia();
    });

    if (!this.thumbnails) return;

    const thumbnailsButtons = this.thumbnails.querySelectorAll('.product-thumbnails__item button');

    thumbnailsButtons.forEach((button, index) => {
      button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.slider.select(index);
        }
      });
    });
  }

  unMount() {
    this.slider.destroy();
    this.sliderNav.destroy();
  }

  onLoad() {
    this.unMount();
    this.mount(this.element, this.thumbnails);
  }

  onUnload() {
    this.unMount();
  }
}

customElements.define('product-media', ProductMedia);
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href]');
  if (!link) return;
  if (link.target === '_blank') return;
  if (link.href === window.location.href) return;

  sessionStorage.setItem(
    `scroll-position:${window.location.pathname}`,
    String(window.scrollY || window.pageYOffset || 0)
  );
});

window.addEventListener('pageshow', (event) => {
  const navEntry = performance.getEntriesByType('navigation')[0];
  const isBackForward =
    event.persisted ||
    (navEntry && navEntry.type === 'back_forward');

  if (!isBackForward) return;

  const savedScroll = sessionStorage.getItem(`scroll-position:${window.location.pathname}`);
  if (!savedScroll) return;

  let attempts = 0;

  const restoreScroll = () => {
    window.scrollTo(0, Number(savedScroll));
    attempts += 1;

    if (attempts < 10) {
      requestAnimationFrame(restoreScroll);
    }
  };

  requestAnimationFrame(restoreScroll);
});
